import React, { useState } from "react";
import "../Navbar/Navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };
  const phoneClick = () => {
    window.location.href = "tel:+919555768358";
  };
  return (
    <>
      <div>
        <header>
          <img src="logo.webp" alt="logo" className="logo-header" />
          <h1 className="head-h1">
            AIG<span className="head-h1-span">in </span>Royal
          </h1>
          <p className="head-p">At Sector 1, Greater Noida West</p>
          <p onClick={phoneClick} className="h">
            +919555768358
          </p>
        </header>
        <nav>
          <ul className={isOpen ? "active" : ""}>
            <a href="#home" onClick={closeMenu}>
              <li>Home</li>
            </a>
            <a href="#price" onClick={closeMenu}>
              <li>Price</li>
            </a>
            <a href="#site&floor" onClick={closeMenu}>
              <li>Site & Floor Plan</li>
            </a>
            <a href="#amenities" onClick={closeMenu}>
              <li>Amenities</li>
            </a>
            <a href="#gallery" onClick={closeMenu}>
              <li>Gallery</li>
            </a>
            <a href="#location" onClick={closeMenu}>
              <li>Location</li>
            </a>

            <a href="#virtualsitetour" onClick={closeMenu}>
              <li>Virtual Site Tour</li>
            </a>

            <a href="#brochure" onClick={closeMenu}>
              <li>Brochure</li>
            </a>
          </ul>
          <div className="handle" onClick={toggleMenu}>
            {isOpen ? "Close" : "Menu"}
          </div>
        </nav>
      </div>
    </>
  );
};

export default Navbar;
